import { render, staticRenderFns } from "./SendEmailsProgress.vue?vue&type=template&id=0dda2422&"
import script from "./SendEmailsProgress.vue?vue&type=script&lang=js&"
export * from "./SendEmailsProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/blocks/SendEmailsProgress.vue
// module id = null
// module chunks = 